import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class RestaurantRatingService extends BaseService {
    constructor() {
        super(apiroutes.RESTAURANT_RATING);
    }

    async create(data) {
        return await super.customCall('POST', '', data, null, 'json');
    }

    async getByCompany(params = {}) {
        return await super.customCall('GET', '', null, params, null);
    }
}

const RestaurantRatingServices = new RestaurantRatingService();
export default RestaurantRatingServices;
